(function (angular, moment, _) {
    // all the validation logic resided in this service so that we can reuse the service anywhere in client side code to validate page, individual questions and summary level validations
    var validationService = function (UtilityServices, Constants) {

        var service = {
            val: valueOfQuestion,
            questionContains: questionContains,
            notEmpty: notEmpty,
            validNumeric: validNumeric,
            validDate: validDate,
            isDateSameOrAfter: isDateSameOrAfter,
            dateDifferenceInDays: dateDifferenceInDays,
            validDateRange: validDateRange,
            validAlphabetic: validAlphabetic,
            validEmailAddress: validEmailAddress,
            isAdult: isAdult
        };

        function valueOfQuestion(params, responses, qCode, sCode, sIndex, pIndex, pageId) {
            // if the params parameter has been supplied, it replaces the value of undefined parameters
            // note the check for undefined is explicit here, because values could be 0 which is acceptable!
            if (params) {
                if (!pIndex && params['pIndex'] != undefined) pIndex = params['pIndex'];
                if (!sIndex && params['sIndex'] != undefined) sIndex = params['sIndex'];
                if (!sCode && params['sCode'] != undefined) sCode = params['sCode'];
                if (!pageId && params['pageId'] != undefined) pageId = params['pageId'];
            }

            // Find matching response.
            if (responses &&
                pageId &&
                responses[pageId] &&
                responses[pageId][pIndex] &&
                responses[pageId][pIndex][sCode]) {
                var response = responses[pageId][pIndex][sCode][sIndex];
                if (response) {
                    for (var responseKey in response) {
                        if (response.hasOwnProperty(responseKey)) {
                            if (responseKey == qCode) {
                                return response[responseKey];
                            }
                        }
                    }
                }
            }
            return undefined;
        }

        // this function returns whether the question contains the value or not
        function questionContains(params, responses, qCode, qValue, sCode, sIndex, pIndex, pageId) {
            var val = valueOfQuestion(params, responses, qCode, sCode, sIndex, pIndex, pageId);
            if (!val || ($.isArray(val) && val.length == 0)) {
                return false;
            }
            return val.indexOf(qValue) > -1;
        }

        // this function tells whether the value of question is not empty
        function notEmpty(params, responses, qCode, sCode, sIndex, pIndex, pageId) {
            var val = valueOfQuestion(params, responses, qCode, sCode, sIndex, pIndex, pageId);
            if (!val || ($.isArray(val) && val.length == 0)) {
                return false;
            }
            return true;
        }

        // Numeric validation check. DO NOT change the order of the input paramaters as parameters may be defined in the surveydefinition.json
        function validNumeric(params, responses, qCode, maxNumericLength, minNumericLength, sCode, sIndex, pIndex, pageId) {
            if (!minNumericLength) {
                minNumericLength = 1;
            }
            if (!qCode || !maxNumericLength || maxNumericLength < minNumericLength) {
                return false;
            }

            var target = valueOfQuestion(params, responses, qCode, sCode, sIndex, pIndex, pageId);
            if (!target) {
                return true; //skip test for blank value
            }
            var regx = new RegExp("^[0-9]{" + minNumericLength + "," + maxNumericLength + "}$");
            return regx.test(target);
        }

        // Alphabetic validation check.
        function validAlphabetic(params, responses, code, sCode, sIndex, pIndex, pageId) {
            if (!code) {
                return false;
            }

            var target = valueOfQuestion(params, responses, code, sCode, sIndex, pIndex, pageId);
            if (!target) {
                return true; //skip test for blank value
            }

            var regx = new RegExp("^[a-zA-Z]+$");
            return regx.test(target);
        }

        // Email validation logic. DO NOT change the order of the input paramaters as parameters may be defined in the surveydefinition.json
        function validEmailAddress(params, responses, qCode, sCode, sIndex, pIndex, pageId) {
            if (!qCode) {
                return false;
            }

            var target = valueOfQuestion(params, responses, qCode, sCode, sIndex, pIndex, pageId);
            if (!target) {
                return true; //skip test for blank value
            }

            return UtilityServices.matchEmailRegx(target);
        }

        // Determines if the date is valid. DO NOT change the order of the input paramaters as parameters may be defined in the surveydefinition.json
        function validDate(params, responses, qCode, sCode, sIndex, pIndex, pageId) {
            if (!qCode) {
                return false;
            }

            var day = notEmpty(params, responses, qCode + '-day', sCode, sIndex, pIndex, pageId);
            var month = notEmpty(params, responses, qCode + '-month', sCode, sIndex, pIndex, pageId);
            var year = notEmpty(params, responses, qCode + '-year', sCode, sIndex, pIndex, pageId);
            var target;
            if (day || month || year) {
                target = valueOfQuestion(params, responses, qCode, sCode, sIndex, pIndex, pageId);
            }
            else {
                return true; //skip test if nothing has been entered for day or month or year
            }

            var isValidDate = moment(target, 'YYYY-MM-DD', true).isValid();

            if (isValidDate) {
                var minDate = moment(Constants.minimumDate).format('YYYY-MM-DD');
                return (this.dateDifferenceInDays(target, minDate) >= 0 ? true : false);
            }

            return isValidDate;
        }

        // Determines if the date is equal to or after the source date
        function isDateSameOrAfter(params, responses, qCode, minYear, sCode, sIndex, pIndex, pageId) {
            if (!qCode || isNaN(minYear)) {
                return false;
            }

            var target = valueOfQuestion(params, responses, qCode, sCode, sIndex, pIndex, pageId);
            if (!target) {
                return true;
            }
            var dateMoment = moment(target, 'YYYY-MM-DD', true);

            return (dateMoment.isValid() && dateMoment.isSameOrAfter(minYear + '-01-01'));
        }

        // Returns the date difference in days
        function dateDifferenceInDays(sDate, tDate) {
            var daysDifference = null;

            var sourceDate = moment(sDate, 'YYYY-MM-DD', true);
            var targetDate = moment(tDate, 'YYYY-MM-DD', true);

            if (sourceDate.isValid() && targetDate.isValid()) {
                daysDifference = sourceDate.diff(targetDate, 'days');
            } else {
                return null;
            }

            return daysDifference;
        }

        // determine where a date is past, future or today
        function validDateRange(params, responses, qCode, sCode, sIndex, pIndex, pageId) {
            if (!validDate(params, responses, qCode, sCode, sIndex, pIndex, pageId)) {
                return 'invalid';
            }

            var target = valueOfQuestion(params, responses, qCode, sCode, sIndex, pIndex, pageId);

            var date = moment(target, "YYYY-MM-DD", true);

            //future
            if (moment().isBefore(date, 'day')) {
                return 'future';
            }
            //same as today
            if (moment().isSame(date, 'day')) {
                return 'today';
            }
            //past
            if (moment().isAfter(date, 'day')) {
                return 'past';
            }

            return '';
        }

        // Returns true if a date has been entered and it is equal to or greater than 18 years.  DO NOT change the order of the input paramaters as parameters may be defined in the surveydefinition.json
        function isAdult(params, responses, qCode, sCode, sIndex, pIndex, pageId) {
            if (!qCode) {
                return false;
            }

            var target = valueOfQuestion(params, responses, qCode, sCode, sIndex, pIndex, pageId);
            if (!target) {
                return false; // should be false because we don't have a date.
            }

            var date = moment(target, "YYYY-MM-DD", true);
            if (date.isValid()) {
                return UtilityServices.isAdult(date.year(), (date.month() + 1), date.date());
            }
            return false;
        }

        return service;
    };

    //Get the formApp module
    var formApp = angular.module('formApp');
    //Register this service with the formApp module
    formApp.factory('ValidationService', ['UtilityServices', 'Constants', validationService]);
}(angular, moment, _));